import api from "@/services/api.service";
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'edit',
  components: {},
  props: [],
  data () {
    return {
      caption:"Edit Role",
      campaigns:[],
      formField:{role:''},
      permissions: [],
      selectedHeadersShow:[],
      checkedHeaders : [],
      submitStatus: null,
      roles:[],
      permission_edit: false,
      superAdmin: false          
    }
  },
  computed: {    
  },
  watch:{          
  },
  mounted () {
  },
  validations: {
    formField: {
      role: {
        required
      }
    }
  },
  async created(){   
    let response = await api.post("users/user-permissions");
        const permissions = [];
        if (response.status == "success") {
          response.data[0].permission.forEach( function(element) {                
              permissions.push(element.action)
          }.bind(this));
            if(permissions.includes("edit_role") == true){   
              this.getUser();
              this.getRoles();
              this.getPermissions();
              this.permission_edit = permissions.includes("edit_role");
            }else if(response.data[0].role == 'super_admin'){
              this.getUser();
              this.getRoles();
              this.getPermissions();
              this.superAdmin = true;
          }else if(permissions.includes("list_role") == true || permissions.includes("add_role") == true){
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'Roles List'});
            }else{
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'Admin Dashboard'});
            }
        }
  },
  methods: {
    makeToast(message = '',title='Alert',variant='warning') {
      this.toastCount++
      this.$root.$bvToast.toast(message, {
        title:title,
        variant:variant,
        autoHideDelay: 3000
      })
    },   
    async getPermissions() {
      
      var response = await  api.post('role-permission/permission-list')
      if (!response)
        this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)
      if (response.status == 'success') {
        if (response.data != '') {          
          response.data.forEach(function(e){                      
            this.permissions.push({value:e.id,text:e.label});
          }.bind(this));                    
        } else {
          this.permissions = [];
          this.makeToast(`No permissions found.`, 'Alert', 'danger')
        }      
      } else
      this.makeToast(`No permissions found.`, 'Alert', 'danger')
    },   
       
    async getRoles() {
      let response = await api.post("role/list");
      if (!response)
        this.makeToast(
          "Something went to wrong please try again",
          "Alert",
          "danger",
          6000
          );
      if (response.status == "success") {
        response.data.data.forEach(
          function(e) {            
            this.roles.push({ value: e.id, text: e.role });
          }.bind(this)
          );
      }
    },    
    async getUser(){        

      let response = await api.post('/role-permission/role-list',{'id':this.$route.params.id});
      
      if(!response)
        this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)
        if(response.status == 'success'){
            this.formField = response.data;  
            this.checked_values = (response.data.permission);
            this.checked_values.forEach( function(element){
            this.checkedHeaders[element.id] = element.id;
            this.selectedHeadersShow.push({text:element.value , value:element.id });
          }.bind(this));

         } else{
          this.makeToast(response.message,'Alert','danger');
        }
    },

    inArray: function(needle, haystack) {    
      var length = haystack.length;
      for(var i = 0; i < length; i++) {
        if(haystack[i].value == needle) return i;
      }
      return false;
    },
    selectedHeaders(index){     
      var is_value = this.inArray(this.permissions[index].value,this.selectedHeadersShow);   
      console.log(is_value); 
      if(is_value !== false){ 
        this.selectedHeadersShow.splice(is_value,1);
      } else {
        this.selectedHeadersShow.push(this.permissions[index]);
        console.log(this.selectedHeadersShow);
      }        
    }, 

   async edit(){
    this.$v.$touch();
    if (this.$v.$invalid) {
      this.submitStatus = 'ERROR'
    } else{

       if (this.selectedHeadersShow.length === 0) {
        this.makeToast("Please, select any columns","Alert","danger",6000);
        return;
      }
      // console.log(this.selectedHeadersShow);
      this.formField.permission = this.selectedHeadersShow; 

      let response = await api.post('/role-permission/update', this.formField);
      if (!response)
        this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

      if(response.status=='success'){
        this.makeToast(response.message,'Success','success');
        this.$router.push({name:"Roles List"})
      }else{
        // for(var error in response.errors){
          this.makeToast(response.message,'Alert','danger');
        // }
      }
    }
  }
}
}


